import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as olStyle from "ol/style";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";
import WKT from "ol/format/WKT";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";

import "./construction.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";
import stl from "../../modal/WorkInfoModal.module.scss";

class Construction extends Component {
	static contextType = LoadingContext; // contextType 사용
	constructor(props) {
		super(props);
		this.previousFeature = null;  // 전역 변수로 previousFeature 선언
		this.state = {
		  title: "건설사업",
		  activeItem: "",
		  lstEmd: [],
		  lstYmd: [],
		  lstGb: [],
		};
	  }
	openSearchWrap = (evt) => {
		$("#constructionWrap .itemsWrap").hide();
		$("#constructionWrap .searchWrap").show();
		$("#constructionWrap .close").show();

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();

		this.setState({
			activeItem: id,
			title,
		});

		/*if(id=="library"){
			this.getYmd("library_info");		
			//this.getGb(id);
		}else if(id=="cultPerf"){
			this.getYmd("cult_perf");		
			//this.getGb(id);
		}else if(id=="cultExhi"){
			this.getYmd("cult_exhi");		
			//this.getGb(id);
		}else if(id=="cultWelf"){
			this.getYmd("cult_welf");		
			//this.getGb(id);
		}else if(id=="cultDist"){
			this.getYmd("cult_dist");		
			//this.getGb(id);
		}*/
	};

	closeSearchWrap = () => {
		$("#constructionWrap .searchWrap").hide();
		$("#constructionWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#constructionWrap .close").hide();

		this.setState({
			activeItem: "",
			title: "건설사업",
		});

	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};
	
	// 오버레이 클릭 이벤트(모달)
	_overlayClickEvent = (ele, id, activeItem, noProps = false,mapZoom = false) => {
		const { actions, layout, sis} = this.props;
		let imageUrl;
		let titleCk = ele.title || "";
		titleCk = titleCk.endsWith(" 정거장") ? titleCk.split(" ").pop() : titleCk;

		if (titleCk === "정거장") return;

		const filename = ele.imagePath || "";
		//const newId = id.replace('_removeOverlay', '');
		//construction_railwayWorks
		if(filename !== ""){
			$.ajax({
				url: `/map/api/images/${filename}`,
				type: "GET",
				async: false,
				success: (res) => {
					//const base64Image = this.arrayBufferToBase64(res);
					//imageUrl = `data:image/jpeg;base64,${base64Image}`;
					imageUrl = `data:image/jpeg;base64,${res}`;
					//imageUrl=res; // state 업데이트
				},
				error: (err) => {
					console.error("이미지를 불러오는데 실패했습니다:", err);
				},
			});
		}
		
		if ("roadWorks,buildingWorks,riverWorks,sewerWorks,railwayWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== "") {
			const modal = layout.get("workInfoModal");

			modal.setContents(
				<div className={stl.contentWrapper}>
					<div className={stl.contentBody}>
						<div className={`${stl.tabContent}`}>
							<table>
								<caption>사업정보</caption>
								<tbody>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>사업명</th>
										<td colSpan="3" style={{fontWeight:"bold"}}>{ele.title ? ele.title : "-"}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>위치</th>
										<td style={{fontWeight:"bold"}}>{ele.location ? ele.location : "-"}</td>
										<th className={`${stl.leftHeader} ${stl.l25}`}>사업규모</th>
										<td style={{fontWeight:"bold"}}>{ele.content ? ele.content : "-"}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>총사업비</th>
										<td style={{fontWeight:"bold"}}>{Number(ele.cost).toLocaleString() ? Number(ele.cost).toLocaleString() : "-"}백만원</td>
										<th className={`${stl.leftHeader} ${stl.l25}`}>사업기간</th>
										<td style={{fontWeight:"bold"}}>{ele.period ? ele.period : "-"}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>추진단계</th>
										<td style={{fontWeight:"bold"}}>{ele.pushAhead ? ele.pushAhead : "-"}</td>
										<th className={`${stl.leftHeader} ${stl.l25}`}>추진기간</th>
										<td style={{fontWeight:"bold"}}>{ele.runTimeStart ? ele.runTimeStart : ""} ~ {ele.runTimeEnd ? ele.runTimeEnd : ""}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>공정률(%)</th>
										<td style={{fontWeight:"bold"}}>{ele.recordRate ? ele.recordRate : "-"}</td>
										<th className={`${stl.leftHeader} ${stl.l25}`}>시행기관</th>
										<td style={{fontWeight:"bold"}}>{ele.implement ? ele.implement : "-"}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`}>담당부서</th>
										<td style={{fontWeight:"bold"}}>{ele.administration ? ele.administration : "-"}</td>
										<th className={`${stl.leftHeader} ${stl.l25}`}>연락처</th>
										<td style={{fontWeight:"bold"}}>{ele.tel ? ele.tel : "-"}</td>
									</tr>
									<tr>
										<th className={`${stl.leftHeader} ${stl.l25}`} >비고</th>
										<td colSpan="3" style={{fontWeight:"bold"}}>{ele.etc ? ele.etc : "-"}</td>
									</tr>

									{imageUrl && (
										<tr>
											<th className={`${stl.leftHeader} ${stl.l25}`}>이미지</th>
											<td colSpan="3">
												<img src={imageUrl} alt="이미지" width="750" height="500" />
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			);
			modal.show();
		}
		if("roadWorks,riverWorks,sewerWorks,railwayWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== ""){
			if (mapZoom) {
				const wktFormat = new WKT();
				const feature = wktFormat.readFeature(ele.geom, {
					dataProjection: "EPSG:5186",
					featureProjection: "EPSG:5186"
				});
			
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				const featureExtent = feature.getGeometry().getExtent(); // 원래 피처의 extent
			
				// ✅ feature와 매칭되는 기존 feature 찾기
				/*let targetFeature = null;
				let targetLayer = null;
			
				// 1. newId로 해당 layer를 찾기
				sis.sisMap.map.getLayers().forEach(layer => {
					// layer의 id가 newId와 일치하는지 확인
					if (layer.get("id") === newId && layer.getSource && layer.getSource().getFeatures) {
						const features = layer.getSource().getFeatures();
						// 해당 레이어의 feature를 순회하여 겹치는 feature 찾기
						features.forEach(f => {
							if (f.getGeometry().intersectsExtent(featureExtent)) { // 범위가 겹치는 feature 찾기
								targetFeature = f;
								targetLayer = layer;
							}
						});
					}
				});
			
				// ✅ 기존 feature 스타일 복구 (확실한 체크)
				if (this.previousFeature && this.previousFeature !== targetFeature) {
					try {
						this.previousFeature.setStyle(null); // 기존 feature 스타일 원래대로 복구
					} catch (e) {
						console.error("이전 Feature 스타일 복구 중 오류 발생:", e);
					}
				}
			
				// ✅ 새로운 feature 스타일 적용
				if (targetFeature && targetLayer) {
					targetFeature.setStyle(new olStyle.Style({
						stroke: new olStyle.Stroke({
							color: 'blue',
							width: 4
						}),
						fill: new olStyle.Fill({
							color: 'rgba(0, 0, 255, 0.3)'
						})
					}));
				}
			
				// ✅ 상태 업데이트 (비동기 업데이트에 안전하게)
				this.previousFeature = targetFeature;*/
			
				// ✅ 지도 뷰가 feature 영역을 맞추도록 처리
				sis.sisMap.view.fit(featureExtent);
			}
		}
		
		if("buildingWorks".indexOf(activeItem) > -1 && activeItem !== ""){
			if (mapZoom) {
				const feature = sis.sisLayer.createFeatureByWKT(ele.geom);
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				sis.sisMap.view.fit(feature.getGeometry().getExtent());
			}
		}
			/*overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.infDskNm}</span>
					<span className="cultureAddress">
						{ele.roadAddr}
						<br />
						{ele.addr}
					</span>
					<span className="cultureTel">전화번호 : {ele.tel ? ele.tel : "-"}</span>
					<span>홈페이지 : {ele.homepage ? ele.homepage : "-"}</span>
					<span className="cultureInfo">- 소개 -</span>
					<span>{ele.infDskIntrd ? ele.infDskIntrd : "-"}</span>
				</>
			);
		}  */
		/*let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			crsCode : "EPSG:5186",
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			mapZoom: true,
		});*/

		return;
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `construction_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		/*if (activeItem === "museum") col = "fcltyNm";
		else if (activeItem === "sightseeing") col = "trrsrtNm";
		else*/if (activeItem === "library") col = "libraryNm";
		else if (activeItem === "cultPerf") col = "cultNam";
		else if (activeItem === "cultExhi") col = "cultNam";
		else if (activeItem === "cultDist") col = "cultNam";
		else col = "title";

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
						this._overlayClickEvent(props, id, activeItem, true);
						sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
		} else {
			this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		// " 정거장"으로 끝나지 않는 요소만 필터링
		const filteredData = data.filter(ele => {
			const title = ele.title || ""; // title이 없거나 null일 경우 빈 문자열로 처리
			return !title.endsWith(" 정거장");
		});
		
  		// 필터링된 배열의 길이 = " 정거장"이 아닌 요소의 개수
  		const countExcludingStations = filteredData.length;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + countExcludingStations.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;
			let titleCk = ele.title || "";
			titleCk = titleCk.endsWith(" 정거장") ? titleCk.split(" ").pop() : titleCk;

			if (titleCk === "정거장") return;

			if ("roadWorks,buildingWorks,riverWorks,sewerWorks,railwayWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== "") {
				let parkGb = ele.pushAhead;
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "공사완료":
						name = "완료";
						classNm = "tag park";
						break;
					case "공사중":
						name = "공사중";
						classNm = "tag park2";
						break;
					case "발주중":
						name = "발주중";
						classNm = "tag park3";
						break;
					case "보상중":
						name = "보상중";
						classNm = "tag park4";
						break;
					case "설계중":
						name = "설계중";
						classNm = "tag park5";
						break;
					case "설계공모중":
						name = "공모중";
						classNm = "tag park6";
						break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm}  style={{marginRight:"3px"}}>{name}</span>
							{ele.title}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.title}</span>`);
			}

			// $(`.lst_${id}_${ele.gid}`).on("click", () => {
			// 	$(`#${id}_${ele.gid}`)[0].click();

			// 	const feature = this.props.sis.sisLayer.createFeatureByWKT(ele.geom);
			// 	feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
			// 	this.props.sis.sisMap.view.fit(feature.getGeometry().getExtent());
			// 	this.props.sis.sisMap.view.setZoom(8);
			// });

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: `${id}_${ele.gid}`,
				crsCode: "EPSG:5186",
				className: "constructionOverlayWrap",
				onClick: this.overlayClickEvent,
				//minZoom: 6,
				//maxZoom: 10,
			});
		});

		// 오버레이 클릭 이벤트
		data.forEach((ele, idx) => {
			
			let titleCk = ele.title || "";
			titleCk = titleCk.endsWith(" 정거장") ? titleCk.split(" ").pop() : titleCk;

			if (titleCk === "정거장") return;

			if ("roadWorks,buildingWorks,riverWorks,sewerWorks,railwayWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== "") {
				
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					(${ele.pushAhead}) ${ele.title}
					</span>`
				);
			} 

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});
		//if(activeItem === "library"||activeItem==="cultPerf"||activeItem==="cultExhi"||activeItem==="cultDist"){
		//	$(".tabWrap .tab.active .searchWrap .listWrap").css("top","225px");
		//}
		$(".tabWrap .tab.active .searchWrap .listWrap").css("top","225px");
		$(".sisOverlayWrap").css("background-color","#FFF0F5");
	};

	// 트리 범례 생성
	createTreeLegend = (props) => {
		const { activeItem } = this.state;

		if ("roadWorks,buildingWorks,riverWorks,sewerWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== "") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block",marginRight: "20px" }} className="tag park">
								완료
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "40px",
								}}
								className="text"
							>
								공사완료
							</span>

							<span style={{ display: "inline-block" }} className="tag park2">
								공사중
							</span>
							<span style={{ display: "inline-block" }} className="text">
								공사중
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park3">
								발주중
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								발주중
							</span>

							<span style={{ display: "inline-block" }} className="tag park4">
								보상중
							</span>
							<span style={{ display: "inline-block" }} className="text">
								보상중
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park5">
								설계중
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								설계중
							</span>

							<span style={{ display: "inline-block" }} className="tag park6">
								공모중
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "10px",
								}}
								className="text"
							>
								설계공모중
							</span>
						</div>
					</div>
					
				</>
				
			);
			
		}else if("railwayWorks".indexOf(activeItem) > -1){
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block",marginRight: "20px" }} className="tag park">
								완료
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "40px",
								}}
								className="text"
							>
								공사완료
							</span>

							<span style={{ display: "inline-block" }} className="tag park2">
								공사중
							</span>
							<span style={{ display: "inline-block" }} className="text">
								공사중
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park3">
								발주중
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								발주중
							</span>

							<span style={{ display: "inline-block" }} className="tag park4">
								보상중
							</span>
							<span style={{ display: "inline-block" }} className="text">
								보상중
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag park5">
								설계중
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "75px",
								}}
								className="text"
							>
								설계중
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag rail1">
								1공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "72px",
								}}
								className="text"
							>
								1공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail2">
								2공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								2공구
							</span>

							<span style={{ display: "inline-block" }} className="tag rail3">
								3공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "68px",
								}}
								className="text"
							>
								3공구
							</span>

							<span style={{ display: "inline-block" }} className="tag rail4">
								4공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								4공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail5">
								5공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "68px",
								}}
								className="text"
							>
								5공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail6">
								6공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								6공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail7">
								7공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "68px",
								}}
								className="text"
							>
								7공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail8">
								8공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								8공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail9">
								9공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "68px",
								}}
								className="text"
							>
								9공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail10">
								10공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "40px",
								}}
								className="text"
							>
								10공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail11">
								11공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "62px",
								}}
								className="text"
							>
								11공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail12">
								12공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "40px",
								}}
								className="text"
							>
								12공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail13">
								13공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "58px",
								}}
								className="text"
							>
								13공구
							</span>
							<span style={{ display: "inline-block" }} className="tag rail14">
								14공구
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "38px",
								}}
								className="text"
							>
								14공구
							</span>
						</div>
					</div>
					
				</>
				
			);
		}
		
		
	};

	// 검색
	search = (evt, id) => {
		const { setLoading } = this.context; // context에서 setLoading 가져오기
    	setLoading(true); 
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;

		let title = "";
		let data = [];
		//let stdYmd = "";
		//let guBun = "0";
		//if(activeItem==="library"||activeItem==="cultPerf"||activeItem==="cultExhi"||activeItem==="cultDist"){
			//stdYmd = $("select#selectEnvironmentStdYmd").val();
			//guBun = $("select#selectEnvironmentGb").val();
		//}

		let params = {
			sggCode: $("select#selectConstructionSgg").val(),
			emdCode: $("select#selectConstructionEmd").val(),
			title: $("#selectConstructionTitle").val().trim() === "" ? null : $("#selectConstructionTitle").val(),
			
			//stdYmd: stdYmd,
			//guBun: guBun,
		};
		let color = "#ff0000";
		let url = "";
		let legend = "";
		let type = "";
		if (activeItem === "roadWorks") {
			title = "도로공사 현황";
			color = "#ec407a";
			url = "/map/selectRoadWorks";
			type = "workPolyline";
			legend = this.createTreeLegend();
		}else if (activeItem === "riverWorks") {
			title = "하천사업 현황";
			color = "#ec407a";
			url = "/map/selectRiverWorks";
			type = "workPolyline";
			legend = this.createTreeLegend();
		}else if (activeItem === "sewerWorks") {
			title = "하수사업 현황";
			color = "#ec407a";
			url = "/map/selectSewerWorks";
			type = "workPolyline";
			legend = this.createTreeLegend();
		}else if (activeItem === "climateWorks") {
			title = "환경·녹지 현황";
			color = "#ec407a";
			url = "/map/selectEcoGreenWorks";
			type = "point";
			legend = this.createTreeLegend();
		}else if (activeItem === "buildingWorks") {
			title = "건축사업 현황";
			color = "#ec407a";
			url = "/map/selectBuildingWorks";
			type = "point";
			legend = this.createTreeLegend();
		}else if (activeItem === "railwayWorks") {
			title = "도시철도 현황";
			color = "#ec407a";
			url = "/map/selectRailwayWorks";
			type = "workPolyline";
			legend = this.createTreeLegend();
		}else if (activeItem === "plannedDevWorks") {
			title = "단지개발 현황";
			color = "#ec407a";
			url = "/map/selectPlannedDevWorks";
			type = "workPolyline";
			legend = this.createTreeLegend();
		}else if (activeItem === "waterSupplyWorks") {
			title = "상수도 현황";
			color = "#ec407a";
			url = "/map/selectWaterSupplyWorks";
			type = "point";
			legend = this.createTreeLegend();
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(`construction_${activeItem}`);

				if (lyr) {
					actions.deleteResult({
						id: `construction_${activeItem}`,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id: `construction_${activeItem}`,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});

				// 레이어 생성
				actions.addResultLayer({
					data,
					id: `construction_${activeItem}`,
					type: type,
					color,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  }
				});
				
				// 오버레이 생성
				this.createOverlay(data, `construction_${activeItem}`);
			},
		});
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		if ("roadWorks,buildingWorks,riverWorks,sewerWorks,railwayWorks,climateWorks,waterSupplyWorks,plannedDevWorks".indexOf(activeItem) > -1 && activeItem !== "") {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectConstructionSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectConstructionEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">사업명</span>
						<label>
							<input
								type="text"
								id="selectConstructionTitle"
								className="select"
								//value=""
								placeholder="사업명을 입력하세요"
								/>
						</label>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="constructionWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="itemsWrap">

					<div id="roadWorks" className="item" onClick={this.openSearchWrap}>
						<span>도로공사 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="buildingWorks" className="item" onClick={this.openSearchWrap}>
						<span>건축사업 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="riverWorks" className="item" onClick={this.openSearchWrap}>
						<span>하천사업 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="sewerWorks" className="item" onClick={this.openSearchWrap}>
						<span>하수사업 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="climateWorks" className="item" onClick={this.openSearchWrap}>
						<span>환경·녹지 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="waterSupplyWorks" className="item" onClick={this.openSearchWrap}>
						<span>상수도 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="railwayWorks" className="item" onClick={this.openSearchWrap}>
						<span>도시철도 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="plannedDevWorks" className="item" onClick={this.openSearchWrap}>
						<span>단지개발 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Construction);
